import React, { Component } from 'react';
import '../css/App.css';
import Amplify from 'aws-amplify';
import Aws_exports from '../aws-exports';
import '@aws-amplify/ui/dist/style.css';
import AWS from 'aws-sdk';
import { BrowserDetection } from './';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

new AWS.Polly();

Amplify.configure(Aws_exports);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#002e6d'
    },
    secondary: {
      main: 'rgba(229, 126, 60,1)'
    }
  }
});
class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <BrowserDetection></BrowserDetection>{' '}
      </ThemeProvider>
    );
  }
}

export default App;
